import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Check, Sparkles } from 'lucide-react';
import { Section } from './ui/Section';
const results = ['Menos polvo acumulado', 'Superficies brillantes', 'Olor fresco por días', 'Menos tiempo limpiando', 'Más descanso y paz mental', 'Orgullo de hogar sin agotamiento'];
const includes = ['Identificación exacta de los 2 ingredientes', 'Dosis, proporciones y preparación segura', 'Secuencia diaria de 15 minutos', 'Checklists imprimibles por áreas', 'Lista de compras editable', 'Calendario de 30 días'];
export function ResultsSection() {
  return <Section background="white" data-id="element-242">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center" data-id="element-243">
        {/* Results Column */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-244">
          <div className="inline-flex items-center gap-2 text-[#2C7A7B] mb-4" data-id="element-245">
            <Sparkles className="w-5 h-5" data-id="element-246" />
            <span className="font-bold uppercase tracking-wider text-sm" data-id="element-247">
              Resultados Reales
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-8" data-id="element-248">
            Tu casa puede mantenerse impecable incluso con caos
          </h2>
          <ul className="space-y-4" data-id="element-249">
            {results.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center gap-3 text-lg text-gray-700" data-id="element-250">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#48BB78]/20 flex items-center justify-center" data-id="element-251">
                  <Check className="w-4 h-4 text-[#48BB78]" strokeWidth={3} data-id="element-252" />
                </div>
                {item}
              </motion.li>)}
          </ul>
        </motion.div>

        {/* What's Included Column with Ebook Cover */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-253">
          {/* Ebook Cover Image */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="relative" data-id="element-254">
            <div className="relative max-w-xs mx-auto" data-id="element-255">
              <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766518194/Caratula_Libro_Casa_impecable_aeltbs.png" alt="Carátula Ebook Casa Impecable con 2 Ingredientes" className="w-full h-auto rounded-lg shadow-2xl" loading="lazy" data-id="element-256" />
              {/* Decorative glow */}
              <div className="absolute -inset-4 bg-[#2C7A7B]/10 rounded-2xl blur-2xl -z-10" data-id="element-257" />
            </div>
          </motion.div>

          {/* What's Included Box */}
          <div className="bg-[#2C7A7B] text-white p-8 md:p-10 rounded-3xl shadow-xl relative overflow-hidden" data-id="element-258">
            {/* Decorative circles */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-16 -mt-16" data-id="element-259" />
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-white/5 rounded-full -ml-10 -mb-10" data-id="element-260" />

            <div className="relative z-10" data-id="element-261">
              <h3 className="text-2xl font-serif font-bold mb-6" data-id="element-262">
                Lo que incluye el método
              </h3>

              <ul className="space-y-4" data-id="element-263">
                {includes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-264">
                    <Check className="w-5 h-5 text-[#D4AF37] mt-0.5 flex-shrink-0" data-id="element-265" />
                    <span className="text-white/90 font-medium" data-id="element-266">{item}</span>
                  </li>)}
              </ul>

              <div className="mt-8 pt-8 border-t border-white/20 text-center" data-id="element-267">
                <p className="text-white/80 text-sm mb-2" data-id="element-268">
                  Resultados esperados:
                </p>
                <p className="font-serif text-xl italic" data-id="element-269">
                  Más tranquilidad. Más tiempo para ti.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </Section>;
}